/* ************************************************************
src/pages/MovieDetails.jsx
OMDb API를 사용하여 영화 정보 조회
동적 세그먼트를 통해 영화 ID를 추출하고 그에 맞는 정보를 가져와 표시하는 예제
**************************************************************/
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styles from './MovieDetails.module.css';

// 1. OMDb API 영화 상세 정보 인터페이스 정의
interface MovieDetail {
  Title: string;
  Year: string;
  Poster: string;
  Plot: string;
  Director: string;
  Actors: string;
  Runtime: string;
  Genre: string;
  // 필요한 속성이 더 있다면 여기에 추가하세요.
}

// 2. useParams의 타입 매개변수 정의
type MovieDetailsParams = {
  movieId: string;
};

export default function MovieDetails() {
  // movie 상태에 MovieDetail 또는 null 타입 지정
  const [movie, setMovie] = useState<MovieDetail | null>(null);
  
  // useParams에 정의한 타입을 적용
  const { movieId } = useParams<MovieDetailsParams>();
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchMovie() {
      if (!movieId) return; // ID가 없는 경우 방지

      try {
        const res = await fetch(`https://www.omdbapi.com/?apikey=7035c60c&i=${movieId}`);
        const data: MovieDetail = await res.json();
        setMovie(data);
      } catch (error) {
        console.error("영화 정보를 가져오는 중 에러 발생:", error);
      }
    }

    fetchMovie();
  }, [movieId]);

  return (
    <div className={styles.modal}>
      <div
        className={styles.overlay}
        onClick={() => navigate(-1)}
      />
      <div className={styles.content}>
        {/* 데이터 로딩 전후 처리 */}
        {movie ? (
          <h1>{movie.Title}</h1>
        ) : (
          <p>정보를 불러오는 중...</p>
        )}
      </div>
    </div>
  );
}